import { render, staticRenderFns } from "./BroadcastDetailPage.vue?vue&type=template&id=53686284&scoped=true"
import script from "./BroadcastDetailPage.vue?vue&type=script&lang=js"
export * from "./BroadcastDetailPage.vue?vue&type=script&lang=js"
import style0 from "./BroadcastDetailPage.vue?vue&type=style&index=0&id=53686284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53686284",
  null
  
)

export default component.exports